/** Datumsangaben für Liste und Leser — kurz, wo Platz knapp ist, vollständig im Tooltip. */

function gueltig(iso: string | null | undefined): Date | null {
  if (!iso) return null;
  const d = new Date(iso);
  return Number.isNaN(d.getTime()) ? null : d;
}

function tagesbeginn(d: Date): number {
  return new Date(d.getFullYear(), d.getMonth(), d.getDate()).getTime();
}

/**
 * Für die Liste: heute die Uhrzeit, gestern „Gestern", in der letzten Woche
 * der Wochentag, im laufenden Jahr Tag und Monat, sonst das volle Datum.
 */
export function datumKurz(iso: string | null | undefined): string {
  const d = gueltig(iso);
  if (!d) return "";
  const jetzt = new Date();
  const tage = Math.round((tagesbeginn(jetzt) - tagesbeginn(d)) / 86_400_000);
  if (tage === 0) return d.toLocaleTimeString("de-DE", { hour: "2-digit", minute: "2-digit" });
  if (tage === 1) return "Gestern";
  if (tage > 1 && tage < 7) return d.toLocaleDateString("de-DE", { weekday: "short" }).replace(".", "");
  if (d.getFullYear() === jetzt.getFullYear()) return d.toLocaleDateString("de-DE", { day: "numeric", month: "short" });
  return d.toLocaleDateString("de-DE", { day: "2-digit", month: "2-digit", year: "numeric" });
}

/** Für Leser und Tooltips: „Mo., 28. Sep. 2026, 14:03". */
export function datumLang(iso: string | null | undefined): string {
  const d = gueltig(iso);
  if (!d) return "";
  return d.toLocaleString("de-DE", {
    weekday: "short",
    day: "numeric",
    month: "short",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
}
